import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { resolveImagePath } from '@/utils/imageMap';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { About } from '@/components/sections/About';
import { Gallery } from '@/components/sections/Gallery';
import { Services } from '@/components/sections/Services';
import { ThingsToDo } from '@/components/sections/ThingsToDo';
import { Testimonials } from '@/components/sections/Testimonials';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        {/* Preload critical hero background image for optimal LCP */}
        <link rel="preload" as="image" href={resolveImagePath('/images/hero-bg.jpg')} fetchPriority="high" />
      </Helmet>
      
      <div className="min-h-screen">
        <Header siteData={siteData} />
        <Hero />
        <About />
        <Gallery />
        <Services />
        <ThingsToDo />
        <Testimonials />
        <Footer siteData={siteData} />
      </div>
    </>
  );
}